'use client';

import { motion } from 'framer-motion';
import type { Dictionary } from '@/lib/i18n';
import Logo from './Logo';

// Deliberately dependency-light (no three.js/rapier) so it can render immediately as the
// hero's LCP content, without waiting on the heavy game bundle to download and execute.
export default function StartScreen({ t, onStart }: { t: Dictionary['game']; onStart: () => void }) {
  return (
    <div className='pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-24'>
      <div className='flex w-full flex-col items-center gap-2'>
        <div className='w-full max-w-[600px]'>
          <Logo className='logo' />
        </div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.5 }}
          className='text-fg -mt-4 px-6 text-center text-sm tracking-[0.2em]'
        >
          {t.intro}
        </motion.p>
      </div>
      <motion.button
        type='button'
        onClick={onStart}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 2 }}
        className='text-fg border-fg hover:bg-fg hover:text-bg text-md pointer-events-auto cursor-pointer border-[1.5px] px-8 py-3 font-normal uppercase transition-colors duration-300'
      >
        {t.tapToPlay}
      </motion.button>
    </div>
  );
}
